import { isDev } from '@/lib/utils';

/** Prod/dev habitat-path toggle, applied at resolve time (see resolvePath). */
const TOUR_IS_DEV = isDev();

export default TOUR_IS_DEV;
